import React from 'react';
import Dropdown from '../Dropdown';
import HomeTypesFilter from 'common/components/HomeTypeFilter';
import Button from 'common/components/Button';
import useFiltersStore from '_viewport-maps/src/store/useFiltersStore';
import { filterDefaults, homeTypeFilterInputs, sendCloseDropdownEvent } from '_viewport-maps/src/util/filters';
import settings, { homeTypesMapping } from '_viewport-maps/src/util/config';
import { BUTTON_TYPES } from 'common/types/forms';
const HomeTypesDropdown = () => {
    const { homeTypes, setHomeTypes, resetHomeTypes, setApplyFilterFlag } = useFiltersStore();
    return (React.createElement(Dropdown, { toggleClass: "filter-dropdown", toggleChildren: React.createElement(React.Fragment, null,
            React.createElement("span", { className: "filter-dropdown__label" }, homeTypes === filterDefaults.homeTypes || homeTypes.length === 0
                ? settings.FilterHomeTypeLabel
                : Object.keys(homeTypesMapping).find(key => homeTypesMapping[key] === homeTypes[0])
                    + (homeTypes[1] ? ' +' : '')),
            React.createElement("i", { className: "filter-dropdown__symbol fas fa-angle-down" })), contentClass: "filter-dropdown__content" },
        React.createElement(HomeTypesFilter, { title: settings.FilterHomeTypeLabel, homeTypeValues: homeTypes, homeTypesData: homeTypeFilterInputs, className: "viewport-map__home-types-filter", onChange: (homeTypesString) => setHomeTypes(homeTypesString) }),
        React.createElement("hr", { className: "filter-horizontal-divider" }),
        React.createElement("div", { className: "flex-between viewport-map__filters__buttons" },
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_LINK, className: "viewport-map__filters__clear-button", onCLick: (event) => {
                    resetHomeTypes();
                    sendCloseDropdownEvent(event.target);
                } }, settings.FilterClearLabel),
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_PRIMARY_SMALL, className: "viewport-map__filters__save-button", onCLick: (event) => {
                    setApplyFilterFlag(true);
                    sendCloseDropdownEvent(event.target);
                } }, settings.FilterSaveLabel))));
};
export default HomeTypesDropdown;
